import { IUserActive } from "redux/reducers/models/user";
import { AuthActionTypes } from "./actionTypes";
import { IAuthAction } from "redux/reducers/auth";
import { IStaffAccountShift } from "redux/reducers/models/shift";
import { GetStaffAccountShift } from "api/rpc/2024-04/facilityAdmin/client/shifts";
import { StatusCode } from "api/protocols";
import {
  CLIENT_DISPATCH_TARGET_APP,
  CLIENT_DISPATCH_TARGET_MASTER,
} from "redux/clientDispatchMeta";
import {
  FACILITY_DISPATCH_TARGET_CLIENT_FACILITY,
  FACILITY_DISPATCH_TARGET_FACILITY,
  FACILITY_DISPATCH_TARGET_MASTER_FACILITY,
} from "redux/facilityDispatchMeta";

type AuthDispatchType = (action: IAuthAction) => void;

export function userLogin(user: IUserActive) {
  return (dispatch: AuthDispatchType) => {
    dispatch({ type: AuthActionTypes.USER_LOGIN, payload: user });
    const d = dispatch as (a: {
      type: string;
      meta: { facilityDispatchTarget: string };
      payload: { facility: null };
    }) => void;
    d({
      type: "facility.update",
      meta: { facilityDispatchTarget: FACILITY_DISPATCH_TARGET_FACILITY },
      payload: { facility: null },
    });
    d({
      type: "facility.update",
      meta: { facilityDispatchTarget: FACILITY_DISPATCH_TARGET_CLIENT_FACILITY },
      payload: { facility: null },
    });
    d({
      type: "facility.update",
      meta: { facilityDispatchTarget: FACILITY_DISPATCH_TARGET_MASTER_FACILITY },
      payload: { facility: null },
    });
    const dc = dispatch as (a: {
      type: string;
      meta: { clientDispatchTarget: string };
      payload: { client: null };
    }) => void;
    dc({
      type: "client.update",
      meta: { clientDispatchTarget: CLIENT_DISPATCH_TARGET_APP },
      payload: { client: null },
    });
    dc({
      type: "client.update",
      meta: { clientDispatchTarget: CLIENT_DISPATCH_TARGET_MASTER },
      payload: { client: null },
    });
  };
}

export function userLogout() {
  return (dispatch: AuthDispatchType) => {
    dispatch({ type: AuthActionTypes.USER_LOGOUT });
  };
}

export function initialize(initialized: boolean) {
  return (dispatch: AuthDispatchType) => {
    dispatch({ type: AuthActionTypes.USER_INITIALIZE, payload: { initialized } });
  };
}

export function loadFacilityAdminShift(useGlobalLoader: boolean) {
  return async (dispatch: any) => {
    const res = await GetStaffAccountShift(useGlobalLoader);
    
    if (res.status !== StatusCode.OK) {
      console.log(res);
      return;
    }

    dispatch({ type: AuthActionTypes.USER_SHIFT, payload: res?.data ?? null });
  };
}

export function setStaffAccountShift(shift: IStaffAccountShift) {
  return (dispatch: AuthDispatchType) => {
    dispatch({ type: AuthActionTypes.USER_SHIFT, payload: shift });
  };
}

export interface IAuthActions {
  userLogin: typeof userLogin;
  userLogout: typeof userLogout;
  initialize: typeof initialize;
  loadFacilityAdminShift: typeof loadFacilityAdminShift;
  setStaffAccountShift: typeof setStaffAccountShift;
}
